import type {Context} from '../types';

export default function dynamicPageLinkFromSlugToFullSlug(context: Context) {
  const {jsonNode} = context.node;

  const dataWHref = jsonNode?.data?.dyn?.bind?.dataWHref;

  const needed = Boolean(
    dataWHref &&
    Array.isArray(dataWHref) &&
    dataWHref.length > 0 &&
    dataWHref[dataWHref.length - 1]?.slug === 'slug'
  );

  return {
    needed,
    logData: {
      msg: 'Migrate Link dataWHref binding from slug field to fullSlug field.',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      dataWHref[dataWHref.length - 1] = {
        id: '',
        slug: 'fullSlug',
        type: 'FullSlug',
      };
    },
  };
}
